import { httpClient } from '../../httpClient'

export type AttachmentWorkflow = {
  id: string
  ideaStepId: string
  fileName: string
  originalName: string
  size: number
  fileType: string
  s3Key: string
  createdAt: string
  url: string
  author: {
    id: string
    name: string
    image: string | null
    area: string | null
  }
}

type WorkflowHttpResponse = {
  id: string
  name: string
  isIdeaOwner: boolean
  ideaSteps: {
    id: string
    title: string
    sequence: number
    completed: boolean
    ideaId: string
    createdAt: string
    attachments: AttachmentWorkflow[]
    ideaStepItems: {
      id: string
      title: string
      completed: boolean
      sequence: number
      ideaStepId: string
      createdAt: string
      responsible: {
        id: string
        name: string
        image: string | null
        area: string | null
      } | null
      limitDate: string
    }[]
  }[]
}

export type Workflow = {
  id: string
  name: string
  isIdeaOwner: boolean
  steps: {
    id: string
    title: string
    completed: boolean
    tasks: {
      id: string
      title: string
      completed: boolean
      responsible: {
        id: string
        name: string
        avatar: string | null
        area: string | null
      } | null
      endDate: Date | null
    }[]
    attachments: AttachmentWorkflow[]
  }[]
}

export const getWorkflow = async (id: string): Promise<Workflow> => {
  const { data } = await httpClient.get<WorkflowHttpResponse>(
    `ideas/funnel/ideas/${id}/workflow`,
  )

  const { ideaSteps = [], ...workflowData } = data

  const workflow: Workflow = {
    id: workflowData.id,
    name: workflowData.name,
    isIdeaOwner: workflowData.isIdeaOwner,
    steps: ideaSteps.map((step) => {
      return {
        id: step.id,
        title: step.title,
        completed: step.completed,
        attachments: step.attachments,
        tasks: step.ideaStepItems.map((task) => {
          return {
            id: task.id,
            title: task.title,
            completed: task.completed,
            responsible: task.responsible
              ? {
                  id: task.responsible.id,
                  name: task.responsible.name,
                  avatar: task.responsible?.image ?? null,
                  area: task.responsible.area ?? null,
                }
              : null,
            endDate: task.limitDate
              ? new Date(task.limitDate.replace('Z', ''))
              : null,
          }
        }),
      }
    }),
  }

  return workflow
}
